import HtmlRenderContainer from '@/components/content-management/html-render-container';
import DesignType from '@/helpers/contentDesign';

export default {
  props: {
    title: {
      type    : String,
      default : ''
    },
    content: {
      type    : Object,
      default : ''
    }
  },
  components: {
    HtmlRenderContainer
  },
  data() {
    return {
      designThumbnailType: DesignType.THUMBNAIL
    };
  }
};
